enum MyleCounterStyle {
    blueCircleWithBackground = "blueCircleWithBackground",
    blueCircleNoBackground = "blueCircleNoBackground",
    redCircleWithBackground = "redCircleWithBackground",
    redCircleNoBackground = "redCircleNoBackground"
}

/**
 * Represents a counter with a value, label, and available styles.
 */
class Counter {
    /** The numerical value of the counter. */
    public value: number;

    /** Optional text description of the counter. */
    public text?: string;

    /** Optional status of the counter. */
    public style?: MyleCounterStyle;

    /**
     * Creates an instance of the Counter class.
     */
    constructor(value: number, text: string, style: MyleCounterStyle) {
        this.value = value;
        this.text = text ?? "";
        this.style = style ?? MyleCounterStyle.blueCircleWithBackground;
    }
}

export { Counter, MyleCounterStyle };
